/**
 * Created by Roman on 2016-09-02.
 */

angular.module('flipto.components.common.eventsRelated', []);
